<template>
    <div>
        <v-container fluid hidden-sm-and-down pa-0>
            <v-jumbotron class="" :gradient="gradient" style="height: 95vh;">
                <v-container fill-height text-xs-center text-sm-left>
                    <v-layout align-center justify-center="">
                        <v-flex xs6 xl5 >
                            <h3 class="display-3">Beco da eletrônica </h3>

                            <span class="subheading"> Uma loja de componentes eletrônicos, robótica e afins, feita por estudantes para estudantes</span>

                            <v-divider class="my-3"></v-divider>

                            <div class="title mb-3">Veja o que vendemos!</div>

                            <v-btn class="mx-0 title" color="primary" :to="'/products/arduino'" large> Produtos </v-btn>
                        </v-flex>

                        <v-flex offset-xs1 xs5 xl4>
                            <img src="../assets/arduino-placa.svg" alt="Placa Arduino" >
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron color="grey lighten-3" height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-sm-left>
                        <v-layout justify-center>
                            <v-flex xl10>
                                <v-toolbar-title class="display-2">
                                        Categorias
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container grid-list-md mb-4>
                    <v-layout row wrap justify-center>
                        <v-flex xs6 xl5 v-for="categoria in categorias" :key="categoria.nome">
                            <v-card dark color="trasnparent">
                                <v-jumbotron style="height: 33vh;" :gradient="categoria.gradiente" dark :src="getImgSVG(categoria.img)" :alt="categoria.nome">
                                    <v-container fill-height pa-0>
                                        <v-layout align-center pa-0>
                                            <v-flex text-xs-center style="height: 100%;" pa-0>
                                                <v-btn block flat style="height: 100%; margin: 0;" :to="'/products/' + categoria.rota">
                                                    <h3 class="display-3">{{categoria.nome}}</h3>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-jumbotron>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 xl10 text-xs-left>
                            <span class="subheading">*Para retirar os produtos, combinar com os responsáveis. </span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-sm-left>
                        <v-layout justify-center>
                            <v-flex xl10>
                                <v-toolbar-title class="display-2">
                                        Quem somos?
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container mb-4 text-xs-center text-sm-left>
                    <v-layout justify-center>
                        <v-flex  xs5 center style="display: flex; align-items: center; justify-content: center;">
                            <img :src="getImgSVG('logo-beco-svg')" alt="Logo Beco" style="height: 525px; width: auto;"> 
                        </v-flex>

                        <v-flex xs5 >
                            <h3 class="display-1 mb-2">O beco</h3>

                            <span class="body-2">É uma loja desenvolvida por estudantes para qualquer pessoa que queira desenvolver seus próprios projetos de eletrônica e robótica, oferecendo os produtos necessários para que isso seja possível </span>
                            <v-divider class="my-3 transparent"></v-divider>

                            <h3 class="display-1">Os fundadores</h3>

                            <v-container style="padding: 25px 0 0 0;" grid-list-md text-xs-center>
                                <v-layout row wrap>
                                    <v-flex xs4 v-for="fundador in fundadores" v-bind:key="fundador.fundadores" hidden-md-and-down>
                                        <v-jumbotron height="auto">
                                            <v-avatar size="125px" class="elevation-5">
                                                <img :src="getImgSVG(fundador.img)" :alt="fundador.nome"> 
                                            </v-avatar>

                                            <v-divider class="my-2 transparent"></v-divider>
                                            <p class="title" style="margin: 5px;">{{fundador.nome}}</p>
                                            <p class="subheading">{{fundador.cargo}}</p>
                                        </v-jumbotron>
                                    </v-flex>

                                    <v-flex xs4 v-for="fundador in fundadores" v-bind:key="fundador.fundadores" hidden-lg-and-up>
                                        <v-jumbotron height="auto">
                                            <v-avatar size="100px" class="elevation-5">
                                                <img :src="getImgSVG(fundador.img)" :alt="fundador.nome"> 
                                            </v-avatar>

                                            <v-divider class="my-2 transparent"></v-divider>
                                            <p class="title" style="margin: 5px;">{{fundador.nome}}</p>
                                            <p class="subheading">{{fundador.cargo}}</p>
                                        </v-jumbotron>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        
                            <v-divider class="my-0 transparent"></v-divider>

                            <v-container style="padding: 25px 0 0 0;">
                                <v-btn class="mx-0 subheading" color="primary" block outline :to="'/about'">
                                    Saiba mais sobre a nós
                                </v-btn>
                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>
        </v-container>

        <v-container fluid hidden-md-and-up pa-0>
            <v-jumbotron class="" :gradient="gradient" style="height: 95vh;">
                <v-container fill-height text-xs-center text-sm-left>
                    <v-layout align-center>
                        <v-flex xs12 text-xs-center>
                            <h3 class="display-3">Beco da eletrônica </h3>

                            <span class="body-2">Uma loja de componentes eletrônicos, robótica e afins, feita por estudantes para estudantes
                             </span>                           
                            <v-divider class="my-3"></v-divider>
                            <div class="title mb-3">Veja o que vendemos!</div>

                            <v-btn class="mx-0 title" color="primary" :to="'/products/arduino'" large> Produtos </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron color="grey lighten-3" height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-xs-center text-sm-left>
                        <v-toolbar-title class="display-1">
                            Categorias
                        </v-toolbar-title>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-divider class="my-0"></v-divider>
                </v-container>

                <v-container grid-list-md text-xs-center mb-4>
                    <v-layout row wrap>
                        <v-flex xs12 v-for="categoria in categorias" :key="categoria.nome">
                            <v-card dark color="trasnparent">
                                <v-jumbotron style="height: 25vh;" :gradient="categoria.gradiente" dark :src="getImgSVG(categoria.img)" :alt="categoria.nome">
                                    <v-container fill-height pa-0>
                                        <v-layout align-center pa-0>
                                            <v-flex text-xs-center style="height: 100%;" pa-0>
                                                <v-btn block flat style="height: 100%; margin: 0;" :to="'/products/' + categoria.rota">
                                                    <h3 class="display-2">{{categoria.nome}}</h3>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-jumbotron>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 text-xs-left>
                            <span class="body-1 font-weight-light">*Para retirar os produtos, combinar com os responsáveis. </span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;">
                    <v-spacer></v-spacer>
                    <v-container text-xs-center>
                        <v-toolbar-title class="display-1">
                            Quem somos
                        </v-toolbar-title>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-divider class="my-0"></v-divider>
                </v-container>

                <v-container mb-4 text-xs-center text-sm-left>
                    <v-layout>
                        <v-flex sm12>
                            <h3 class="headline" style="margin-bottom: 10px;">O beco</h3>

                            <span class="body-2">É uma loja desenvolvida por estudantes para qualquer pessoa que queira desenvolver seus próprios projetos de eletrônica e robótica, oferecendo os produtos necessários para que isso seja possível </span>
                            <v-divider class="my-3 transparent"></v-divider>

                            <h3 class="headline">Os fundadores</h3>

                            <v-container style="padding: 25px 0 0 0;" grid-list-md text-xs-center>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 v-for="fundador in fundadores" v-bind:key="fundador.fundadores">
                                        <v-jumbotron height="auto">
                                            <v-avatar size="25vh" class="elevation-5">
                                                <img :src="getImgSVG(fundador.img)" :alt="fundador.nome"> 
                                            </v-avatar>

                                            <v-divider class="my-2 transparent"></v-divider>
                                            <p class="title" style="margin: 5px;">{{fundador.nome}}</p>
                                            <p class="body-2">{{fundador.cargo}}</p>
                                        </v-jumbotron>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        
                            <v-divider class="my-0 transparent"></v-divider>

                            <v-container style="padding: 25px 0 0 0;">
                                <v-btn class="mx-0 subheading" color="primary" block outline :to="'/about'">
                                    Saiba mais sobre a nós
                                </v-btn>
                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>
        </v-container>
    </div>
</template>

<script>
export default {
  data() {
    return {
      gradient: "to top, rgba(0,0,0,0.1), rgba(0,0,0,0.0)",
      categorias: [
        {
          img: "catArduino",
          nome: "Arduino",
          rota: "arduino",
          gradiente: "to top, rgba(0,0,0,0.5), rgba(0,0,0,0.25)"
        },
        {
          img: "catPrototipagem",
          nome: "Prototipagem",
          rota: "prototipagem",
          gradiente: "to top, rgba(0,0,0,0.5), rgba(0,0,0,0.25)"
        },
        {
          img: "catRobotica",
          nome: "Robótica",
          rota: "robotica",
          gradiente: "to top, rgba(0,0,0,0.5), rgba(0,0,0,0.25)"
        },
        {
          img: "catComponentes",
          nome: "Componentes",
          rota: "componentes",
          gradiente: "to top, rgba(0,0,0,0.5), rgba(0,0,0,0.25)"
        }
      ],
      fundadores: [
        { img: "luan", nome: "Luan Carlos", cargo: "Dev. Web Full-Stack" },
        { img: "toin", nome: "Mateus Antonio", cargo: "Dev. Projetos / Maker" },
        { img: "felipe", nome: "Felipe Nunes", cargo: "Dev. Mobile" }
      ]
    };
  },
  methods: {
    getImgSVG(path) {
      var images = require.context("../assets/", false, /\.svg$/);
      return images("./" + path + ".svg");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home.vue